import { v4 as uuidv4 } from 'uuid';
import jwt from "jsonwebtoken";
import * as Sentry from '@sentry/nextjs';
import * as tus from 'tus-js-client';

// borrowed from https://stackoverflow.com/a/21742107/6362872
export function getMobileOs() {
    try {
      const userAgent = navigator.userAgent || navigator.vendor;
      if (/android/i.test(userAgent)) {
        return "Android";
      }
      if (/iPad|iPhone|iPod/.test(userAgent)) {
        return "iOS";
      }
    } catch (e) {
      // Nothing serious, this is failing when prerendering on server with "ReferenceError: navigator is not defined"
    }
    return "unknown";
}

export function newJwtWithExpiration(data: { address: string, ens: string }) {
  return jwt.sign(data, process.env.JWT_SECRET!, { expiresIn: '180 days' })
}

export function validateEmail(email: string) {
    return /\S+@\S+\.\S+/.test(email);
}

export function buildURLParams(params: Record<string, string | number | null | undefined>) {
  Object.keys(params).forEach(
    (key) => {
      if (params[key] === undefined || params[key] === '' || params[key] === null) {
        delete params[key]
      } else if (typeof params[key] === 'number') {
        params[key] = params[key]?.toString();
      }
    }
  );
  return new URLSearchParams(params as Record<string, string>);
}

export async function uploadFileToSupabase(
  supabaseUrl: string,
  supabaseKey: string,
  uri: string,
  bucketName: string,
  onProgress: (bytesUploaded: number, bytesTotal: number) => void,
  path?: string
) {
  try {
    const res = await fetch(uri);
    const blob = await res.blob();
    const contentType = blob.type.startsWith('image') ? 'image/jpg' : 'video/mp4';
    const fname = `${path}${uuidv4()}.${contentType === 'video/mp4' ? 'mp4' : 'jpg'}`;
    await new Promise((resolve, reject) => {
      const upload = new tus.Upload(blob, {
        endpoint: `${supabaseUrl}/storage/v1/upload/resumable`,
        retryDelays: [0, 3000, 5000, 10000, 20000],
        headers: {
          authorization: `Bearer ${supabaseKey}`
        },
        uploadDataDuringCreation: true,
        metadata: {
          bucketName,
          objectName: fname,
          contentType
        },
        chunkSize: 6 * 1024 * 1024, // NOTE: it must be set to 6MB (for now) do not change it
        onError: (error: any) => reject(error),
        onProgress,
        onSuccess: () => {
          if (upload.url) {
            resolve(upload.url)
          } else {
            reject(new Error('Error uploading video to supabase'));
          }
        },
      })
      upload.start();
    });
    return fname;
  } catch (err) {
    console.log(err)
    Sentry.captureException(err);
  }
}